































	import { Component } from "../../../Infrastructure/CorBase/CoreBase";
	import SellerListBase from "./SellerListBase";

	@Component
	export default class sellerList extends SellerListBase {
		created() {
            super.initializeRights('COR_Seller_Update', 'COR_Seller_Update', 'COR_Seller_Update', 'COR_Seller_Update');
            super.setDetailName('SellerDetail');
			super.created();
		
		}

		selectRows(items: any) {
			super.selectRows(items);
		}

        isSuperUserAllow(){
			return this.isSuperUser;
        }

	
		showAllertToDeleteClick(itemsSelected: any) {
			this.showAlertBeforeDeleteBase(itemsSelected);
		}


		loadFilters(value: any) { super.loadFilters(value); }
		createNewClick(elementId: any) { super.createNewClick(elementId); }
		detailClick(elementId: any) { super.detailClick(elementId); }
		deleteClick(elementId: any) { this.deleteClick(elementId) }
	};
